import React from "react";

export function KycStep({ children, labelledBy, className = "" }) {
  return (
    <section
      aria-labelledby={labelledBy}
      className={`kyc-step-shell mx-auto flex h-full min-h-0 w-full max-w-2xl flex-col justify-start ${className}`.trim()}
    >
      {children}
    </section>
  );
}
